import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=471fc678&scoped=true&"
import script from "./TaskDetail.vue?vue&type=script&lang=ts&"
export * from "./TaskDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=471fc678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471fc678",
  null
  
)

export default component.exports